import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const buyers = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Diego',
  city: 'Córdoba'
}, {
  name: 'Alejandro',
  city: 'Rosario'
}, {
  name: 'Facundo',
  city: 'Mendoza'
}, {
  name: 'Javier',
  city: 'La Plata'
}, {
  name: 'Tomás',
  city: 'Mar del Plata'
}, {
  name: 'Lucas',
  city: 'Neuquén'
}, {
  name: 'Nicolás',
  city: 'Tucumán'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-101">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: '-50%'
    }} animate={{
      opacity: 1,
      y: 0,
      x: '-50%'
    }} exit={{
      opacity: 0,
      y: 20,
      x: '-50%'
    }} className="fixed bottom-6 left-1/2 z-50 w-[90%] max-w-sm bg-brand-card rounded-lg shadow-xl border border-brand-green/30 p-4 flex items-start gap-3" data-id="element-102">
          <div className="bg-brand-green/15 p-2 rounded-full shrink-0 border border-brand-green/30" data-id="element-103">
            <CheckCircle2 className="w-6 h-6 text-brand-green" data-id="element-104" />
          </div>
          <div className="flex-1" data-id="element-105">
            <p className="text-sm font-body font-semibold text-white" data-id="element-106">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs font-body text-gray-400 mt-0.5" data-id="element-107">
              Acaba de comprar este libro digital
            </p>
            <p className="text-xs font-body text-gray-500 mt-1" data-id="element-108">
              Hace unos minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-500 hover:text-gray-300 transition-colors" data-id="element-109">
            <X className="w-4 h-4" data-id="element-110" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}